import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { environment } from '@env';

import { useAuth } from '@/context/AuthProvider';

export interface UpcomingEvent {
  id: number | string;
  title?: string;
  description?: string;
  start?: string;
  event_date?: string;
  end?: string;
  all_day?: boolean;
  source: 'database' | 'ai';
  event_type?: string;
  tenant_id?: string | number;
  property_location_id?: number;
  building?: {
    id: number;
    name: string;
  };
  unit?: {
    id: number;
    name: string;
  };
  tenant?: {
    id: number;
    full_name: string;
  };
  external_document_id?: string;
  document_metadata?: {
    metadata?: Record<string, unknown>;
  };
}

export const useGetUpcomingEvents = (
  propertyLocationId: number | undefined,
  days = 30,
  enabled = true
) => {
  const { session } = useAuth();

  return useQuery({
    enabled: !!session?.access_token && !!propertyLocationId && enabled,
    queryKey: ['GET', 'calendar-events', 'upcoming', propertyLocationId, days],
    queryFn: async (): Promise<UpcomingEvent[]> => {
      const response = await axios.get<UpcomingEvent[]>(
        `${environment.api}/calendar-events/upcoming`,
        {
          params: {
            property_location_id: propertyLocationId,
            days,
          },
          headers: {
            Authorization: `Bearer ${session?.access_token}`,
          },
        }
      );
      return response.data;
    },
  });
};
